module.exports = __webpack_public_path__ + "orcid_logo.4f52185822183931d9b397450fa61a46.png";